module.exports = __webpack_public_path__ + "assets/img/31.d9470cd9.png";